import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import backgroundImg from './img/background.jpg'
import photoImg from './img/photo.png'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSingleName },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro283">
      <div className="intro283mobile screen">
        <div className="black-eOofQG"></div>
        <img className="main-background-eOofQG" src={backgroundImg} />
        <div className="container-center-horizontal">
          <div className="button-eOofQG">
            <p
              className="site-de-casamento-e-sas2aG"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-sas2aG">
              <div className="button-wSYoBj"></div>
              <div className="pular-introduo-wSYoBj" onClick={onSkipIntro}>
                {buttonMessage}
              </div>
            </div>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="couple-name-eOofQG">
            <h1 className="notranslate couple-simplified-nam-tPb5O4 neontubes2-regular-normal-french-pass-48px bp1-intro283-animate-enter2">
              {coupleSingleName.bride.trim()[0]}
            </h1>
            {coupleSingleName.groom && (
              <>
                <div className="x-tPb5O4 neontubes2-regular-normal-french-pass-48px bp1-intro283-animate-enter1">
                  &amp;
                </div>
                <div className="notranslate couple-simplified-nam-HKMfO2 neontubes2-regular-normal-french-pass-48px bp1-intro283-animate-enter">
                  {coupleSingleName.groom.trim()[0]}
                </div>
              </>
            )}
          </div>
        </div>
        <div className="container-center-horizontal">
          <img className="a-photo169-eOofQG" src={background || photoImg} />
        </div>
      </div>
      <div className="intro283desktop screen">
        <div className="black-a5jazN"></div>
        <img className="main-background-a5jazN" src={backgroundImg} />
        <div className="container-center-horizontal">
          <div className="button-a5jazN">
            <p
              className="site-de-casamento-e-LWLj7O"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-LWLj7O">
              <div className="button-tSBDsW"></div>
              <div className="pular-introduo-tSBDsW" onClick={onSkipIntro}>
                {buttonMessage}
              </div>
            </div>
          </div>
        </div>
        <div className="container-center-horizontal">
          <div className="couple-name-a5jazN">
            <div className="notranslate couple-simplified-nam-1afsKW neontubes2-regular-normal-french-pass-48px bp2-intro283-animate-enter2">
              {coupleSingleName.bride.trim()[0]}
            </div>
            {coupleSingleName.groom && (
              <>
                <div className="x-1afsKW neontubes2-regular-normal-french-pass-48px bp2-intro283-animate-enter1">
                  &amp;
                </div>
                <div className="notranslate couple-simplified-nam-yGs8nD neontubes2-regular-normal-french-pass-48px bp2-intro283-animate-enter">
                  {coupleSingleName.groom.trim()[0]}
                </div>
              </>
            )}
          </div>
        </div>
        <div className="container-center-horizontal">
          <img className="a-photo169-a5jazN" src={background || photoImg} />
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
